



<div class="card-deck p-3 text-center">

    <div class="card mb-4 box-shadow">
      <div class="card-header">
        <h4 class="my-0 font-weight-normal">Premium</h4>
      </div>
      <div class="card-body" *ngIf="loading && !error" >

        <div class="text-center">
          <h3>
            Please wait we are processing your payment... 
          </h3>
          <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        
        
      </div>
      <div *ngIf="type!='gift'">
        <div class="card-body" *ngIf="!cancel && !error && address">
          <h1 class="card-title pricing-card-title" *ngIf="address.country == 'France'">19€</h1>
          <h1 class="card-title pricing-card-title" *ngIf="address.country == 'Canada'">$39 (CAD)</h1>
          <h1 class="card-title pricing-card-title" *ngIf="address.country == 'United States'">$29 (USD)</h1>
          <h5 class="card-title pricing-card-title" *ngIf="address.country == 'France'"><small class="text-muted" style="text-decoration: line-through;">29€</small></h5>
          <h5 class="card-title pricing-card-title" *ngIf="address.country == 'Canada'"><small class="text-muted" style="text-decoration: line-through;">$59</small></h5>
          <h5 class="card-title pricing-card-title" *ngIf="address.country == 'United States'"><small class="text-muted" style="text-decoration: line-through;">$49</small></h5>
          <ul class="list-unstyled mt-3 mb-4">
            <div class="p-1">
              <h5><mat-icon >done</mat-icon> 1 Postcard sent from Paris (France)</h5>
            </div>
            <div class="p-1">
              <h5><mat-icon >done</mat-icon>1 Postcard sent from Marseille (France)</h5>
            </div>
            <div class="p-1">
              <h5><mat-icon >done</mat-icon>1 Postcard sent from Bordeaux (France)</h5>
            </div>
            <div class="p-1">
              <h5><mat-icon >done</mat-icon>1 Postcard sent from Nice (France)</h5>
            </div>
            <div class="p-1">
              <h5><mat-icon >done</mat-icon>1 Postcard sent from Versailles (France)</h5>
            </div>
            <div  class="p-1">
              <h5><mat-icon >done</mat-icon><b>1 Postcard medal at the end of the race</b></h5>
            </div>
            <div class="p-1">
              <h6>Premium Support</h6>
            </div>
          </ul>
        <div  clss="p-2">
            <button
            style="background-color:#6772E5;color:#FFF;padding:8px 12px;border:0;border-radius:4px;font-size:1em"
            (click)="goToStripe()"
            role="link">
              Pay Now
            </button>
        </div>
        </div>
      </div>

      <div clss="p-2" *ngIf="type=='gift'"> 
        
        <h5 class="card-title pricing-card-title p-2">Apply you gift code here :</h5>

        <mat-form-field>
          <mat-label>Gift code</mat-label> 
          <input matInput type="text" class="form-control" name="code" id="code" [(ngModel)]="code">
        </mat-form-field>

        <button
        style="background-color:#6772E5;color:#FFF;padding:8px 12px;border:0;border-radius:4px;font-size:1em"
        (click)="useCode()"
        clss="m-2"
        role="link">
          Apply
        </button>

        {{ codeError }}
      </div>

      <div class="card-body" *ngIf="error">
        An error occured, payment canceled.
      </div>
      <div class="card-body" *ngIf="cancel">
        <h3>The payment has been canceled</h3>
        <div><mat-icon  class="p-2 icon-display">cancel_presentation</mat-icon></div>
        <button  mat-raised-button class="m-2" (click)="restart()">Restart the premium process</button>
        <button  mat-raised-button class="m-2" routerLink="/dashboard">Back to the dashboard</button>
      </div>


      
    </div>
  
  </div>